<div #formContainer class="form" [class.sm]="size == 'sm'" [class.lg]="size == 'lg'">
    <ng-content></ng-content>
</div>